(function () {
  'use strict';

  // Year-range -> engine options per make. Kept self-contained here rather
  // than reusing the older homepage-filter scripts.
  function getEngineOptions(make, year) {
    var y = parseInt(year, 10);
    var options = [];

    function push(value, label) {
      options.push({ value: value, label: label || value });
    }

    switch (make) {
      case 'Ford':
        if (y === 2001 || y === 2002) push('All Engines');
        if (y >= 2003 && y <= 2007) push('6.0L Powerstroke', '6.0L');
        if (y >= 2008 && y <= 2010) push('6.4L Powerstroke', '6.4L');
        if (y >= 2011) push('6.7L Powerstroke', '6.7L');
        break;
      case 'Dodge Ram':
        if (y <= 2004) push('All Engines');
        if (y >= 2005 && y <= 2007) push('5.9L Cummins', '5.9L');
        if (y >= 2007) push('Cummins 6.7L', '6.7L');
        if (y >= 2014 && y <= 2023) push('EcoDiesel 3.0L', '3.0L');
        break;
      case 'GM/Chevy':
        if (y >= 2001 && y <= 2004) push('6.6L LB7 Duramax');
        if (y >= 2004 && y <= 2005) push('6.6L LLY Duramax');
        if (y >= 2006 && y <= 2007) push('6.6L LBZ Duramax');
        if (y >= 2007 && y <= 2010) push('6.6L LMM Duramax');
        if (y >= 2011 && y <= 2016) push('6.6L LML Duramax');
        if (y >= 2017) push('L5P');
        if (y >= 2016 && y <= 2022) push('2.8L Duramax');
        break;
      case 'Nissan':
        push('5.0L');
        break;
      case 'Jeep':
        push('3.0L');
        break;
    }

    return options;
  }

  function populateEngineOptions(engineSelect, make, year) {
    engineSelect.innerHTML = '<option value="">Select engine</option>';
    var options = getEngineOptions(make, year);
    options.forEach(function (opt) {
      var el = document.createElement('option');
      el.value = opt.value;
      el.textContent = opt.label;
      engineSelect.appendChild(el);
    });
    engineSelect.disabled = options.length === 0;
  }

  function initFitFinder(section) {
    var collectionUrl = section.dataset.collectionUrl;
    var make = section.dataset.make;

    var yearSelect = section.querySelector('[data-ram-year]');
    var engineSelect = section.querySelector('[data-ram-engine]');
    var productTypeSelect = section.querySelector('[data-ram-product-type]');
    var submitBtn = section.querySelector('[data-ram-submit]');
    var resetBtn = section.querySelector('[data-ram-reset]');
    var results = section.querySelector('[data-ram-results]');
    var countEl = section.querySelector('[data-ram-count]');
    var resultsCountEl = section.querySelector('[data-ram-results-count]');
    var selectionEl = section.querySelector('[data-ram-selection]');
    var productTypesLoaded = false;

    if (!collectionUrl) {
      console.warn('[ram-fit-finder] No collection selected in section settings — nothing to fetch.');
      return;
    }
    if (!yearSelect || !engineSelect || !submitBtn || !resetBtn || !results) return;

    function setLoading(isLoading) {
      results.classList.toggle('is-loading', isLoading);
    }

    function updateCount(doc) {
      var countSource =
        doc.querySelector('#ProductCountDesktop') || doc.querySelector('#ProductCount');
      var text = countSource ? countSource.textContent.trim() : 'all';
      if (countEl) countEl.textContent = text;
      if (resultsCountEl) resultsCountEl.textContent = text;
    }

    function extractGrid(html) {
      var parser = new DOMParser();
      return parser.parseFromString(html, 'text/html');
    }

    function populateProductTypes(doc) {
      if (!productTypeSelect || productTypesLoaded) return;
      var inputs = doc.querySelectorAll('input[name="filter.p.product_type"]');
      if (!inputs.length) return;
      var seen = new Set();
      productTypeSelect.innerHTML = '<option value="">All types</option>';
      inputs.forEach(function (input) {
        if (seen.has(input.value)) return;
        seen.add(input.value);
        var opt = document.createElement('option');
        opt.value = input.value;
        opt.textContent = input.value;
        productTypeSelect.appendChild(opt);
      });
      productTypeSelect.disabled = false;
      productTypesLoaded = true;
    }

    function bindPaginationLinks() {
      results.querySelectorAll('.pagination a[href]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var href = link.getAttribute('href');
          fetchAndRender(href);
        });
      });
    }

    function fetchAndRender(url) {
      setLoading(true);

      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = extractGrid(html);
          var gridContainer = doc.querySelector('#ProductGridContainer');
          results.innerHTML = gridContainer ? gridContainer.innerHTML : doc.body.innerHTML;
          updateCount(doc);
          populateProductTypes(doc);
          bindPaginationLinks();
        })
        .catch(function (err) {
          console.error('[ram-fit-finder] Failed to load products:', err);
        })
        .finally(function () {
          setLoading(false);
        });
    }

    yearSelect.addEventListener('change', function () {
      var year = yearSelect.value;
      if (!year) {
        engineSelect.innerHTML = '<option value="">Select engine</option>';
        engineSelect.disabled = true;
        return;
      }
      populateEngineOptions(engineSelect, make, year);
    });

    function buildCollectionUrl(extraParams) {
      var params = ['filter.v.availability=1'].concat(extraParams || []);
      return collectionUrl + '?' + params.join('&');
    }

    function updateSelectionText() {
      if (!selectionEl) return;
      var parts = [];
      if (yearSelect.value) parts.push(yearSelect.value);
      if (engineSelect.value && engineSelect.value !== 'All Engines') {
        parts.push(engineSelect.value);
      }
      if (productTypeSelect && productTypeSelect.value) {
        parts.push(productTypeSelect.value);
      }
      selectionEl.textContent = parts.length ? ' — ' + parts.join(', ') : '';
    }

    submitBtn.addEventListener('click', function () {
      var params = [];
      if (yearSelect.value) {
        params.push('filter.p.m.custom.year=' + encodeURIComponent(yearSelect.value));
      }
      if (engineSelect.value && engineSelect.value !== 'All Engines') {
        params.push('filter.p.m.custom.engine=' + encodeURIComponent(engineSelect.value));
      }
      if (productTypeSelect && productTypeSelect.value) {
        params.push('filter.p.product_type=' + encodeURIComponent(productTypeSelect.value));
      }
      updateSelectionText();
      fetchAndRender(buildCollectionUrl(params));
    });

    resetBtn.addEventListener('click', function () {
      yearSelect.value = '';
      engineSelect.innerHTML = '<option value="">Select engine</option>';
      engineSelect.disabled = true;
      if (productTypeSelect) productTypeSelect.value = '';
      updateSelectionText();
      fetchAndRender(buildCollectionUrl());
    });

    // Initial load — unfiltered on year/engine, but still excludes out-of-stock items.
    fetchAndRender(buildCollectionUrl());
  }

  function init() {
    document.querySelectorAll('[data-ram-fit-finder]').forEach(initFitFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
